"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploadFile = void 0;
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var mime_types_1 = __importDefault(require("mime-types"));
var react_1 = require("react");
var use_files_api_1 = require("./use-files-api");
function useUploadFile() {
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(), error = _b[0], setError = _b[1];
    var notifications = (0, next_notifications_1.useNotifications)();
    var filesApi = (0, use_files_api_1.useFilesApi)();
    function uploadFile(file, refs, defaultCategory) {
        return __awaiter(this, void 0, void 0, function () {
            /**
             * getContentType
             * If a dropped file doesnt have contentType set, try and get get from the file name.
             * This was the case with uploading MY_FILE.msg - where the Web File Api wouldnt
             * set the contentType on drop.
             * This falls back to 'unknown' which is not great, but should help us debug the issue
             * @param droppedFile
             * @returns string
             */
            function getContentType(droppedFile) {
                if (!droppedFile.type || droppedFile.type) {
                    var contentType = mime_types_1.default.lookup(droppedFile.name);
                    return contentType || 'application/octet-stream';
                }
                return droppedFile.type;
            }
            var attachmentObject, _a, uploadUrl, fileToUpload, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        setError(undefined);
                        notifications.addById('use-upload-hook', {
                            title: "Uploading...",
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, filesApi.getSignedUrl({
                                authRefs: refs === null || refs === void 0 ? void 0 : refs.authRefs,
                                objectRefs: refs === null || refs === void 0 ? void 0 : refs.objectRefs,
                                primaryRefs: refs === null || refs === void 0 ? void 0 : refs.primaryRefs,
                                filename: file.name,
                                contentType: getContentType(file),
                                contentLength: "".concat(file.size),
                                category: defaultCategory,
                            })];
                    case 2:
                        _a = _b.sent(), uploadUrl = _a.uploadUrl, fileToUpload = _a.file;
                        // Did we get an uploadUrl?
                        if (!uploadUrl)
                            throw new Error("Unable to retrieve an uploadUrl': ".concat(uploadUrl, "."));
                        // Upload contents and then commit the file
                        return [4 /*yield*/, filesApi.uploadContents(uploadUrl, file)];
                    case 3:
                        // Upload contents and then commit the file
                        _b.sent();
                        return [4 /*yield*/, filesApi.commit(fileToUpload.id)];
                    case 4:
                        attachmentObject = _b.sent();
                        // Did we get an attachment object from committing the file?
                        if (!attachmentObject)
                            throw new Error("Unable to retrieve an attachment object: ".concat(attachmentObject));
                        return [3 /*break*/, 7];
                    case 5:
                        e_1 = _b.sent();
                        setError(e_1);
                        notifications.addById('use-upload-hook', {
                            title: "There was a problem uploading this file. ".concat(e_1),
                            type: 'error',
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, attachmentObject];
                }
            });
        });
    }
    return [(0, react_1.useCallback)(uploadFile, [filesApi, notifications]), loading, error];
}
exports.useUploadFile = useUploadFile;
